/**
 * View mode for the case file side panel (original asset vs OCR plain text).
 * Use these values instead of string literals across the client.
 */
export const FILE_VIEW_MODE = {
  ORIGINAL: "original",
  OCR: "ocr",
} as const;

export type FileViewMode = (typeof FILE_VIEW_MODE)[keyof typeof FILE_VIEW_MODE];
